const initState = '';
const funcToExport = (state = initState, action) => {
  switch (action.type) {
    case 'FABODY_OBJECT':
      // console.log('action.payload: ', action.payload);
      return action.payload;
    default:
      return state;
  }
};
export default funcToExport;
